module.exports = __webpack_public_path__ + "img/particle_motion_00082.15a95265.png";